<template>
<v-container>
    <v-row class="margin-center"> 
      <v-form class="mt-5 col-12" v-model="isFormValid" @submit.prevent="onSubmit" name="form">
        <v-col cols="12" sm="6" md="12" class="plr-none">
            <v-text-field 
              id="name"
              label="Ime Servisa"
              filled
              v-model="profile.name"
              required
              :rules="nameRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="12" class="d-flex flex-row pt-0 pb-0">
              <v-text-field  cols="12"
              label="Pib"
              filled
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              :counter="9"
              maxlength = "9"
              v-model.number="profile.pib"
              type="number"
               :rules="pibRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="12" class="plr-none">
            <v-text-field
              label="Vlasnik Servisa"
              filled
              v-model="profile.owner"
              required
              :rules="ownerRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="12" class="d-flex flex-row pt-0 pb-0">
            <v-text-field cols="6" class="mr-2"
              label="Ulica Servisa"
              filled
              v-model="profile.adress"
              required
              :rules="adressRules"
            ></v-text-field>
            <v-text-field cols="6"
              label="Broj"
              filled
              v-model="profile.num"
              required
              :rules="numRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="12" class="plr-none">
            <v-autocomplete
              id="place"
              :items="items"
              :filter="customFilter"
              filled
              item-text="name"
              label="Mesto"
              v-model="profile.city"
              :rules="cityRules"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="12" class="p-none">
            <v-btn id="filled" class="mr-4 ml-4" :disabled="!isFormValid" width="-webkit-fill-available" small height="50"  rounded color="primary"  @click="updateProfile">POTVRDI</v-btn>
          </v-col>
    </v-form>
    </v-row>
</v-container>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, maxLength } from 'vuelidate/lib/validators'

  import firebase from 'firebase'
  import {db,fb} from '../main'

  export default {
    name: 'Info',
    mixins: [validationMixin],

    validations: {
      name: { required },
      pib:  { required, maxLength: maxLength(9) },
      owner: { required },
      city: { required },
      adress: { required },
      num: { required },
    },

    data: () => ({
      isFormValid: false,
      items: [
        'Ada 24430', 
        'Adaševci 22244',
        'Adorjan 24425',
        'Adrani 36203',
        'Ajvalija 38205',
        'Aleksa Šantić 25212',
        'Aleksandrovac 12370',
        'Aleksandrovac 37230',
        'Aleksandrovo 18252',
        'Aleksandrovo 23217',
        'Aleksinac 18220',
        'Aleksinački Rudnik 18226',
        'Alibunar 26310',
        'Aliđerce 17523',
        'Aljinovići 31307',
        'Apatin 25260',
        'Aradac 23207',
        'Aranđelovac 34300',
        'Arilje 31230',
        'Ašanja 22418',
        'Atenica 32104',
        'Azanja 11423',
        'Babe 11450',
        'Babin Kal 18315',
        'Babušnica 18330',
        'Bač 21420',
        'Bačevci 31258',
        'Bačina 37265',
        'Bačinci 22225',
        'Bačka Palanka 21400',
        'Bačka Topola 24300',
        'Bački Breg 25275',
        'Bački Brestovac 25242',
        'Bački Gračac 25252',
        'Bački Jarak 21234',
        'Bački Monoštor 25272',
        'Bački Petrovac 21470',
        'Bački Sokolac 24343',
        'Bački Vinogradi 24415',
        'Bačko Dobro Polje 21465',
        'Bački Gradište 21217',
        'Bačko Novo Selo 21429',
        'Bačko Petrovo Selo 21226',
        'Baćevac 11460',
        'Badnjevac 34226',
        'Badovinci 15358',
        'Bagrdan 35204',
        'Bajina Bašta 31250',
        'Bajmok 24210',
        'Bajša 24331',
        'Bakionica 31210',
        'Balajinac 18257',
        'Balosave 34230',
        'Baljevac na Ibru 36344',
        'Banatska Subotica 26327',
        'Banatska Dubica 23251',
        'Banatska Topola 23315',
        'Banatski Brestovac 26234',
        'Banatski Despotovac 23242',
        'Banatski Dvor 23213',
        'Banatski Karlovac 26320',
        'Banatsko Aranđelovo 23332',
        'Banatsko Karađorđevo 23216',
        'Banatsko Novo Selo 26314',
        'Banatsko Veliko Selo 23312',
        'Banatsko Višnjićevo 23237',
        'Banačina 11424',
        'Banoštor 21312',
        'Banovci 22303',
        'Banovo Polje	15362',
        'Banja 34304',
        'Banja (kod Priboja) 31337',
        'Banja Koviljača 15316',
        'Banjani 14214',
        'Banjska 38216',
        'Barajevo 11460',
        'Barajevo 11460',
        'Barane 38307',
        'Barbatovac 18426',
        'Bare 12227',
        'Bare 34205',
        'Bare 36315',
        'Barice 26367',
        'Barič 11500',
        'Barlovo 18432',
        'Baroševac 11565',
        'Bašaid	23316',
        'Batinac 35230',
        'Batočina 34227',
        'Batrovci 22251',
        'Bavanište 26222',
        'Beče	21220',
        'Bečmen 11279',
        'Begaljica 11308',
        'Begeč 21411',
        'Begejci 23232',
        'Bela Crkva	15313',
        'Bela Crkva	26340',
        'Bela Palanka 18310',
        'Bela Voda 37253',
        'Bela Zemlja 31311',
        'Belanovica	14246',
        'Bele Vode 32259',
        'Belegiš 22306',
        'Beleš 18320',
        'Beli Potok	11223',
        'Beli Potok 19366',
        'Belo Blato 23205',
        'Belo Polje	11500',
        'Beloljin	18424',
        'Belosavci 34312',
        'Beloševac 14000',
        'Belotinac 18411',
        'Belušić 35263',
        'Beljina 11461',
        'Beočin 21300',
        'Beograd 11000',
        'Berkasovo 22242',
        'Beršići 32305',
        'Beserovina 31256',
        'Bešenovo	22212',
        'Beška 22324',
        'Bezdan	25270',
        'Bigrenica 35238',
        'Bikić Do	22254',
        'Bikovo 24206',
        'Biljača 17522',
        'Bingula 22253',
        'Bioska	31241',
        'Bistar 17546',
        'Bistražin 38360',
        'Bistrica	31325',
        'Blace 18420',
        'Blaževo	37226',
        'Blendija	18230',
        'Bobište 16000',
        'Bobovo	35217',
        'Bočar 23274',
        'Bođani 21427',
        'Bogaraš 24408',
        'Bogatić 15350',
        'Bogava 35223',
        'Bogdanje 37240',
        'Bogojevce 16000',
        'Bogojevo 25245',
        'Bogovađa 14225',
        'Bogovina 19372',
        'Bogutovac 36341',
        'Bojnik 16205',
        'Boka 23252',
        'Boleč 11307',
        'Boljevac	19370',
        'Boljevci 11275',
        'Boljkovci 32312',
        'Bor 19210',
        'Bor 19218',
        'Borča 11211',
        'Bosilegrad 17540',
        'Bosut 22217',
        'Bošnjace 16232',
        'Bošnjane 35254',
        'Bošnjane 37262',
        'Botoš 23243',
        'Boždarevac 11460',
        'Božetići 31322',
        'Boževac 12313',
        'Božica 17537',
        'Braćevac 19315',
        'Bradarac 12225',
        'Braničevo 12222',
        'Brankovina 14201',
        'Brasaljce 38256',
        'Brasina 15317',
        'Bratinac 12225',
        'Bratljevo 32256',
        'Bratmilovce 16000',
        'Brđani 32303',
        'Brekovo 31234',
        'Bresje 35270',
        'Bresnica 32213',
        'Bresno Polje 37242',
        'Brestač 22415',
        'Brestov. Banja 19216',
        'Brestovac 16253',
        'Brestovac 19210',
        'Brezjak 15309',
        'Brezna 32307',
        'Brezova 32253',
        'Brezovica 38157',
        'Brežane 12207',
        'Brežđe 14244',
        'Brgule 14212',
        'Brnjica 12230',
        'Brodarevo 31305',
        'Brodosavce 38423',
        'Brus 37220',
        'Brusnik 19313',
        'Brvenik 36346',
        'Brza 16203',
        'Brza Palanka 19323',
        'Brzan 34228',
        'Brzeće 37225',
        'Bubušinac 12000',
        'Bučje 19369',
        'Bučje 37243',
        'Budisava 21242',
        'Budisavci 38319',
        'Buđanovci 22421',
        'Bujanovac 17520',
        'Bukorovac 34217',
        'Bukovac 21209',
        'Bukovče 19316',
        'Bukovče 19316',
        'Bukovik 34301',
        'Buljane 35254',
        'Bumbarevo Brdo 34242',
        'Bunar 35273',
        'Burdimo 18368',
        'Burovac 12307',
        'Busilovac 35249',
        'Carevac 12253',
        'Cerova 31230',
        'Cerovac 11420',
        'Cerovac 15224',
        'Cerovac 34321',
        'Crepaja 26213',
        'Crkvine 36321',
        'Crna Bara 15355',
        'Crna Bara 23328',
        'Crna Trava 16215',
        'Crni Kao 34227',
        'Crnoklište 18304',
        'Crvena Jabuka 14210',
        'Crvena Reka 18313',
        'Crvenka 25220',
        'Čačak 32000',
        'Čajetina 31310',
        'Čalma 22231',
        'Čantavir 24220',
        'Čečina 18417',
        'Čelarevo 21413',
        'Čenej 21233',
        'Čenta 23266',
        'Čerević 21311',
        'Čestereg 23215',
        'Češljeva Bara 12253',
        'Čibukovac 36000',
        'Čifluk Razgojnski 16251',
        'Čitluk 18232',
        'Čitluk 37208',
        'Čoka 23320',
        'Čonoplja 25210',
        'Čortanovci 22326',
        'Čukljenik 16203',
        'Čukojevac 36220',
        'Čumić 34322',
        'Čurug 21238',
        'Ćelije 14224',
        'Ćićevac 37210',
        'Ćovdin 12306',
        'Ćuprija 35230',
        'D.Jugovića 38243',
        'Dašnica 37235',
        'Davidovac 19320',
        'Debeljača 26214',
        'Debrc 15214',
        'Deč 22441',
        'Dečane	38322',
        'Dedina 37000',
        'Deliblato 26225',
        'Delimeđe	36307',
        'Deronje 25254',
        'Desimirovac 34321',
        'Despotovac	35213',
        'Despotovo 21468',
        'Deveti maj 18250',
        'Devojački Bunar 26316',
        'Deževa 36305',
        'Dimitrovgrad 18320',
        'Divci 14222',
        'Divčibare 14204',
        'Divljaka 31236',
        'Divostin 34204',
        'Divoš 22232',
        'Dljin 32240',
        'Dobanovci 11272',
        'Dobra 12224',
        'Dobra Voda 38315',
        'Dobri Do 18408',
        'Dobrica 26354',
        'Dobrić 15235',
        'Dobrinci 22412',
        'Dobrovodica 34227',
        'Dolac 18314',
        'Dolovo 26227',
        'Doljevac 18410',
        'Donja Bela Reka 19213',
        'Donja Borina 15317',
        'Donja Crnišava 37243',
        'Donja Dobrinja 31214',
        'Donja Gorevnica 32210',
        'Donja Gušterica 38209',
        'Donja Jajina 16000',
        'Donja Kamenica 19352',
        'Donja Livadica 11326',
        'Donja Ljubata 17544',
        'Donja Mutnica 35255',
        'Donja Nevlja 18325',
        'Donja Orovica 15323',
        'Donja Rečica 18404',
        'Donja Sabanta 34206',
        'Donja Šatornja 34314',
        'Donja Trnava 18202',
        'Donja Trnava 34324',
        'Donje Crnatovo 18414',
        'Donje Crniljevo 15227',
        'Donje Dragovlje 18242',
        'Donje Konjuvce 16205',
        'Donje Krajince 16000',
        'Donje Međurovo 18254',
        'Donje Sinkovce 16000',
        'Donje Vidovo 35258',
        'Donje Zuniče 19345',
        'Donji Barbeš 18241',
        'Donji Bunibrod 16000',
        'Donji Dušnik 18242',
        'Donji Krčin 37258',
        'Donji Matejevac 18204',
        'Donji Milanovac 19220',
        'Donji Ribnik 37243',
        'Donji Stajevac 17526',
        'Donji Tavankut 24214',
        'Doroslovo 25243',
        'Dračić 14203',
        'Draga 36320',
        'Dragaš 38420',
        'Draginac 15311',
        'Draginje 15226',
        'Draglica 31317',
        'Dragobraća	34231',
        'Dragocvet 35272',
        'Dragoševac 35262',
        'Dragovo 35265',
        'Drajkovce 38239',
        'Dražanj 11430',
        'Draževac 11506',
        'Draževac 18223',
        'Drenovac 15212',
        'Drenovac 35257',
        'Drlače 15324',
        'Drmanovići 31320',
        'Drugovac 11432',
        'Dublje 15359',
        'Dublje 35210',
        'Duboka 12255',
        'Dubona 11433',
        'Dubovac 26224',
        'Dubovo 18406',
        'Dubovo 36320',
        'Dubravica 12207',
        'Dudovica 11561',
        'Duga Poljana 36312',
        'Dugo Polje 18237',
        'Dupljaja 26328',
        'Dušanovac 19335',
        'Duvanište 15305',
        'Dvorane 37206',
        'Džep 17514',
        'Džigolj 18405',
        'Đakovica 38320',
        'Đala 23335',
        'Đeneral Janković 38238',
        'Đunis 37202',
        'Đurakovac 38330',
        'Đurđevo 21239',
        'Đurđevo 34215',
        'Đurđin 24213',
        'Đurinci 11450',
        'Ečka 23203',
        'Elemir 23208',
        'Erdeč 34207',
        'Erdevik 22230',
        'Farkaždin 23264',
        'Feketić 24323',
        'Futog 21410',
        'Gabrovac 18106',
        'Gadžin Han 18240',
        'Gaj 26223',
        'Gajdobra 21432',
        'Gakovo 25282',
        'Gamzigradska Banja 19228',
        'Gardinovci	21247',
        'Gibarac 22258',
        'Glavica 35250',
        'Glavinci 35261',
        'Glibovac 11420',
        'Globoder 37251',
        'Glogonj 26202',
        'Glogovac 15355',
        'Glogovac 35222',
        'Glogovac 38313',
        'Gložan 21412',
        'Glušci 15356',
        'Gnjilan 18300',
        'Gnjilane 38250',
        'Godačica 36220',
        'Gola Glava	14201',
        'Golobok 11316',
        'Golubac 12223',
        'Golubinci 22308',
        'Goračići 32232',
        'Goraždevac 38310',
        'Goričani 32224',
        'Gorjani 31205',
        'Gornja Dobrinja 31214',
        'Gornja Draguša 18425',
        'Gornja Gorevnica 32205',
        'Gornja Lisina 17538',
        'Gornja Mutnica	35255',
        'Gornja Omašnica 37242',
        'Gornja Sabanta 34206',
        'Gornja Toplica 14243',
        'Gornja Toponica 18202',
        'Gornja Trepča 32215',
        'Gornja Trnava 34324',
        'Gornja Vrežina 18207',
        'Gornje Jarušice 34322',
        'Gornje Krajince 16000',
        'Gornje Rataje 37230',
        'Gornje Stopanje 16000',
        'Gornji Banjani 32306',
        'Gornji Barbeš 18241',
        'Gornji Breg 24406',
        'Gornji Brestovac 16244',
        'Gornji Katun 37260',
        'Gornji Matejevac 18204',
        'Gornji Milanovac 32300',
        'Gornji Stepoš 37221',
        'Gornji Streoc 38329',
        'Gornji Stupanj 37234',
        'Gornji Tavankut 24214',
        'Gorobilje 31210',
        'Gospođinci	21237',
        'Grabovac 11508',
        'Grabovac 35210',
        'Grabovac 37240',
        'Grabovci 22423',
        'Grabovica 19323',
        'Gračanica 38205',
        'Gradskovo 19205',
        'Granice 11409',
        'Graševci 37229',
        'Grčac 11420',
        'Grdelica 16220',
        'Grdica 36000',
        'Grdovići 31230',
        'Grebenac	26347',
        'Gredetin 18213',
        'Grejač 18219',
        'Grgurevci 22213',
        'Grlište 19342',
        'Grljan	19341',
        'Grocka 11306',
        'Grošnica 34202',
        'Gruža 34230',
        'Guberevac 34232',
        'Guča 32230',
        'Gudurica 26335',
        'Gunaroš 24312',
        'Guncati 11460',
        'Guševac 18208',
        'Hajdučica 26370',
        'Hajdukovo 24414',
        'Hetin 23235',
        'Horgoš 24410',
        'Hrtkovci 22427',
        'Hum 18106',
        'Idvor 26207',
        'Iđoš	23323',
        'Ilandža 26352',
        'Ilićevo 34203',
        'Ilinci 22250',
        'Inđija 22320',
        'Irig 22406',
        'Iriški Venac	22407',
        'Isakovo 35227',
        'Istok 38335',
        'Ivankovac 35238',
        'Ivanovo 26233',
        'Ivanje	31300',
        'Ivanjica 32250',
        'Izbište 26343',
        'Izvor 35255',
        'Jabučje 14226',
        'Jabuka	26201',
        'Jabuka 31306',
        'Jabukovac 19304',
        'Jadranska Lešnica 15308',
        'Jagnjilo 11412',
        'Jagodina 35000',
        'Jakovo 11276',
        'Jalovik 15225',
        'Jamena 22248',
        'Janošik 26362',
        'Janjevo 38233',
        'Jarak 22426',
        'Jarčujak 36000',
        'Jarkovac 23250',
        'Jasenovo 26346',
        'Jasenovo 31319',
        'Jasenovo 35241',
        'Jasika 37252',
        'Jasikovica 37240',
        'Jasikovo 19256',
        'Jaša Tomić 23230',
        'Jazak 22409',
        'Jazovnik 15214',
        'Jazovo 23327',
        'Jelašnica 17531',
        'Jelašnica 18206',
        'Jelav 15307',
        'Jelen Do 31215',
        'Jelenča 15000',
        'Jelovik 34309',
        'Jermenovci 26363',
        'Jermenovci 34318',
        'Jevremovac 15000',
        'Ježevica 31213',
        'Ježevica 32222',
        'Jošanica 18234',
        'Jošanička Banja 36345',
        'Jovac 35205',
        'Jovanovac 18258',
        'Jovanovac 34211',
        'Jugbogdanovac 18253',
        'Junik 38327',
        'Junkovac	11562',
        'Kačanik 38237',
        'Kačarevo 26212',
        'Kačer 31311',
        'Kać 21241',
        'Kadina Luka 14240',
        'Kajtasovo 26329',
        'Kalna 19353',
        'Kaluđerica	11130',
        'Kaluđerske Bare 31257',
        'Kamenica 14252',
        'Kamenica 15222',
        'Kamenica 18324',
        'Kamenica 32206',
        'Kamenovo 12300',
        'Kamijevo 12253',
        'Kanjiža 24420',
        'Kaona 32234',
        'Kaonik 37256',
        'Karađorđevo 21421',
        'Karađorđevo 24308',
        'Karan 31204',
        'Karavukovo 25255',
        'Karlovčić 22443',
        'Kaševar 18420',
        'Katun 18225',
        'Kelebija 24104',
        'Kevi 24407',
        'Kijevo 38316',
        'Kikinda 23300',
        'Kisač 21211',
        'Kladovo 19320',
        'Klek 23211',
        'Klenak 22424',
        'Klenike 17524',
        'Klenje 12258',
        'Klenje 15357',
        'Kličevac 12209',
        'Klina 38317',
        'Klisura 17535',
        'Klokočevac 19222',
        'Klokot 38261',
        'Klupci 15300',
        'Kljajićevo 25221',
        'Knić 34240',
        'Knićanin 23265',
        'Knjaževac 19350',
        'Kobišnica 19316',
        'Koceljeva 15220',
        'Kočino Selo 35220',
        'Kokin Brod	31318',
        'Kolare 35242',
        'Kolari 11431',
        'Kololeč 38264',
        'Kolut 25274',
        'Komanice 14242',
        'Komirić 14254',
        'Konak 23253',
        'Konarevo 36340',
        'Končarevo 35219',
        'Končulj 17520',
        'Konjevići 32212',
        'Konjuh 11415',
        'Korbevac 17545',
        'Korbovo 19329',
        'Korenita 15302',
        'Korman 18216',
        'Korman 34224',
        'Kosančić 16206',
        'Kosjerić 31260',
        'Kosovo Polje 38210',
        'Kosovska Kamenica 38260',
        'Kosovska Mitrovica 38220',
        'Kostojevići 31254',
        'Kostol 19320',
        'Kostolac 12208',
        'Koševi 37208',
        'Koštunići 32308',
        'Kotešica 14201',
        'Kotraža 32235',
        'Kovačevac 11409',
        'Kovačevac 31300',
        'Kovači 36103',
        'Kovačica 26210',
        'Kovanluk 36000',
        'Kovilj 21243',
        'Kovilje 32257',
        'Kovin 26220',
        'Kragujevac 34000',
        'Kragujevac 34113',
        'Krajišnik 23231',
        'Kraljevci 22411',
        'Kraljevo 36000',
        'Kraljevo 36103',
        'Krastavče 18242',
        'Krčedin 22325',
        'Krćevac 34310',
        'Kremna 31242',
        'Krenta 19350',
        'Krepoljin 12316',
        'Kriva Feja 17543',
        'Kriva Reka 31312',
        'Kriva Reka 37282',
        'Krivaja 24341',
        'Krivelj 19219',
        'Krivi Vir 19375',
        'Krnule 15225',
        'Krnješevci 22314',
        'Krnjevo 11319',
        'Krpimej 38246',
        'Krupac 18307',
        'Krupanj 15314',
        'Krušar 35227',
        'Krušce 18250',
        'Kruščica	26340',
        'Kruščica 31233',
        'Kruščić 25225',
        'Krušedol 22328',
        'Kruševac 37000',
        'Kruševica 18409',
        'Kruševo 38426',
        'Kucura 21466',
        'Kučevo 12240',
        'Kukljin 37255',
        'Kukujevci 22224',
        'Kula 12311',
        'Kula 25230',
        'Kulina 18214',
        'Kulinovci 32104',
        'Kulpin 21472',
        'Kumane 23271',
        'Kumarevo 16000',
        'Kupci 37222',
        'Kupinik 26368',
        'Kupinovo 22419',
        'Kupusina 25262',
        'Kurjače 12221',
        'Kuršumlija 18430',
        'Kuršumlijska Banja 18435',
        'Kusadak 11425',
        'Kusić 26349',
        'Kusiće 12222',
        'Kušići 32258',
        'Kušiljevo 35226',
        'Kuštilj 26336',
        'Kuzmin 22223',
        'Laćarak 22221',
        'Laćisled 37232',
        'Lađevci 36204',
        'Lajkovac 14224',
        'Lalić 25234',
        'Lalinac 18201',
        'Lalinac 18256',
        'Lapovo (Varoš) 34220',
        'Lazarevac 11550',
        'Lazarevo 23241',
        'Laznica 12321',
        'Lebane 16230',
        'Lebina 35250',
        'Lece 16248',
        'Ledinci 21207',
        'Lelić 14205',
        'Lenovac 19343',
        'Lepenac 37224',
        'Lepenica 17513',
        'Leposavić 38218',
        'Leskovac 16000',
        'Lešak 38219',
        'Lešnica 15307',
        'Leštane 11309',
        'Ležimir 22207',
        'Lički Hanovi 18245',
        'Lipar 25232',
        'Lipe 11310',
        'Lipljan 38232',
        'Liplje 14240',
        'Lipnički šor 15300',
        'Lipolist 15305',
        'Lipovac 37000',
        'Lisa 32250',
        'Lisović 11460',
        'Loćika 35274',
        'Lok 21248',
        'Lokve 26361',
        'Lovćenac 24322',
        'Loznica 15300',
        'Lozovik 11317',
        'Lubnica 19208',
        'Lučane 17520',
        'Lučani 32240',
        'Lučica 12000',
        'Lug 21315',
        'Lugavčina 11321',
        'Lukare 36306',
        'Lukavac 14222',
        'Luke 32250',
        'Lukićevo 23261',
        'Lukino Selo 23224',
        'Lukovo 18437',
        'Lukovo 19371',
        'Lužane 38244',
        'Lužane	38244',
        'Ljig 14240',
        'Ljuba 22255',
        'Ljubava 37254',
        'Ljuberađa 18217',
        'Ljubić 32103',
        'Ljubiš 31209',
        'Ljubovija 15320',
        'Ljukovo 22321',
        'Ljuljaci 34205',
        'Mačkat 31312',
        'Mačvanska Mitrovica 22202',
        'Maglić 21473',
        'Magura 38234',
        'Majdan 23333',
        'Majdan	32300',
        'Majdanpek 19250',
        'Majilovac 12221',
        'Majur 15353',
        'Majur 35270',
        'Makce 12254',
        'Makrešane 37000',
        'Mala Bosna 24217',
        'Mala Drenova 37246',
        'Mala Ivanča 11233',
        'Mala Krsna 11313',
        'Mala Moštanica 11261',
        'Mala Plana 18423',
        'Mala Vranjska 15224',
        'Malča 18207',
        'Male Pijace 24416',
        'Mali Beograd 24309',
        'Mali Iđoš 24321',
        'Mali Izvor 19347',
        'Mali Jasenovac 19209',
        'Mali Požarevac 11235',
        'Mali Zvornik 15318',
        'Malo Crniće 12311',
        'Malo Golovode 37000',
        'Malo Krčmare 34212',
        'Malošište 18415',
        'Mamuša 38417',
        'Manđelos 22208',
        'Manojlovce 16201',
        'Maradik 22327',             
        'Margita 26364',
        'Markovac 11325',
        'Markovica 32243',       
        'Maršić 34209',
        'Martinci 22222 ',
        'Martonoš 24417',             
        'Mataruška Banja 36201',
        'Medoševac 18209',
        'Medveđa 16240',    
        'Medveđa 35224',
        'Medveđa 37244',
        'Međa 23234',             
        'Međulužje 11400',
        'Međurečje 32255',
        'Melenci 23270',       
        'Melnica 12305',
        'Meljak 11426',
        'Merćez 18436',             
        'Merdare 18445',
        'Merošina 18252',
        'Mesarci 15214',
        'Metković 15356',
        'Metlić 15233',
        'Metovnica 19204',       
        'Mićunovo 24300',
        'Mihajlovac 11312',
        'Mihajlovac 19322',             
        'Mihajlovo 23202',
        'Mijatovac 35236',
        'Milatovac 12320',
        'Milatovići 32234',
        'Milentija 37227',
        'Mileševo 21227',       
        'Miletićevo 26373',
        'Milićevci 32205',
        'Miliva 35213',             
        'Miloševac 11318',
        'Miloševo 35268',
        'Miloševo 38206',
        'Milutovac 37246',
        'Miljević 12222',
        'Minićevo 19340',       
        'Miokovci 32205',
        'Mionica 14242',
        'Mirilovac 35250',             
        'Mirosaljci 11567',
        'Miroševce 16204',
        'Mislođin 11500',
        'Mišar 15000',
        'Mišićevo 24210',
        'Mitrovac 31251',       
        'Mladenovac 11400',
        'Mladenovo 21422',
        'Mojsinje 32211',             
        'Mokra Gora 31243',
        'Mokranja 19317',
        'Mokrin 23305',
        'Mol 24435',
        'Molovin 22256',
        'Moravac 18210',       
        'Moravci 14240',
        'Morović 22245',
        'Mošorin 21245',             
        'Mozgovo 18229',
        'Mramor 18251',
        'Mramorak 26226',
        'Mrčajevci 32210',
        'Mršinci 32224',
        'Mrštane 16000',       
        'Mudrakovac 37000',
        'Muhovac 17529',
        'Mur 36300',             
        'Murgaš 14210',
        'Mustapić 12254',
        'Mušutište 38416',
        'Mužinac 18235',
        'Mužlja 23206',
        'Nadalj 21216',       
        'Nakovo 23311',
        'Nakrivanj 16203',
        'Natalinci 34313',             
        'Negotin 19300',
        'Nemenikuće 11450',
        'Neresnica 12242',
        'Neštin	21314',
        'Neuzina 23245',
        'Nikinci 22422',       
        'Nikola Tesla 18110',
        'Nikolinci 26322',
        'Niš 18000',             
        'Niševac 18366',
        'Niška Banja 18205',
        'Noćaj 22203',
        'Nova Crnja 23218',
        'Nova Crvenka 25224',
        'Nova Gajdobra 21431',       
        'Nova Pazova 22330',
        'Nova Varoš 31320',
        'Novaci 37230',             
        'Novi Banovci 22304',
        'Novi Bečej 23272',
        'Novi Bračun 37216',
        'Novi Itebej 23236',
        'Novi Karlovci 22322',       
        'Novi Kneževac 23330',
        'Novi Kozarci 23313',
        'Novi Kozjak 26353',             
        'Novi Pazar 36300',
        'Novi Sad 21000',
        'Novi Slankamen 22323',
        'Novi Žednik 24223',
        'Novo Brdo 38255',
        'Novo Lanište 35271',       
        'Novo Miloševo 23273',
        'Novo Orahovo 24351',
        'Novo Selo 18250',             
        'Novo Selo 36216',
        'Nozrina 18228',
        'Njegoševo 24311',
        'Obajgora 31250',
        'Obilić 38212',
        'Oblačina 18252',       
        'Obrenovac 11500',
        'Obrež 22417',
        'Obrež 37266',             
        'Obrovac 21423',
        'Odžaci 25250',
        'Odžaci 37240',
        'Ogar 22416',
        'Omoljica 26230',
        'Oparić 35267',       
        'Opovo 26204',
        'Orahovac 38430',
        'Orane 16233',             
        'Oraovica 17523',
        'Orašac 34308',
        'Oreovica 12370',
        'Oreškovica 12308',
        'Orid 15213',
        'Orlane 38245',       
        'Orlovat 23263',
        'Orljane 18410',
        'Orom 24207',             
        'Osaonica 12317',
        'Osečina 14253',
        'Osipaonica 11314',
        'Osmakova 18304',
        'Osnić 19378',       
        'Osojane 38334',
        'Osonica 32250',
        'Ostojićevo 23326',             
        'Ostrikovac 35230',
        'Ostrovica 18312',
        'Ostružnica 11251',
        'Ošljane 19340',
        'Ovča 11212',
        'Ovčar Banja 32242',       
        'Pačir 24342',
        'Padej 23325',
        'Padež 37257',             
        'Padina 26215',
        'Padinska Skela 11213',
        'Pakovraće 32102',
        'Palić 24413',
        'Palilula 18363',
        'Paljane 35238',       
        'Pambukovica 14213',
        'Pančevo 26000',
        'Panonija 24330',             
        'Paraćin 35250',
        'Parage 21434',
        'Parmenac 32102',
        'Parta 26325',
        'Partizani 34305',
        'Parunovac 37201',       
        'Pasjane 38266',
        'Pavliš 26333',
        'Pecka 14207',             
        'Pečenjevce 16251',
        'Peć 38300',
        'Pećinci 22410',
        'Pejkovac 18413',
        'Pepeljevac 18430',
        'Perlez 23260',       
        'Pertate 16232',
        'Perućac 31256',
        'Petlovača 15304',             
        'Petnica 14104',
        'Petnica 32224',
        'Petrovac (na Mlavi) 12300',     
        'Petrovaradin 21132',       
        'Petrovčić 11282',
        'Pinosava 11226',
        'Pirot 18300',             
        'Pivnice 21469',
        'Plana 35247',
        'Plandište 26360',
        'Planinica 19207',
        'Platičevo 22420',
        'Plavna 21428',       
        'Plažane 35212',
        'Pleš 37238',
        'Ploča 37237',             
        'Pločica 26229',
        'Pobeda 24313',
        'Pocerski Pričinović 15000',
        'Počekovina 37243',
        'Počuta 14206',
        'Podujevo 38240',       
        'Podunavci 36215',
        'Podvis 19362',
        'Podvrška 19321',             
        'Poganovo 18326',
        'Pojate 37214',
        'Poljana 12372',
        'Poljna 37246',
        'Poljska Ržana 18300',
        'Popadić 14243',       
        'Popinci 22428',
        'Popovac 18211',
        'Popovac 35254',             
        'Popović 11233',
        'Popučke 14221',
        'Porodin 12375',
        'Potočac 35207',
        'Požaranje 38258',
        'Požarevac 12000',       
        'Požega 31210',
        'Prahovo 19330',
        'Pranjani 32308',             
        'Predejane 16222',
        'Prekodolce 17510',
        'Prekonoga 18365',     
        'Preljina 32212',
        'Preševo 17523',       
        'Prevešt 35264',
        'Prhovo 22442',
        'Priboj 31330',             
        'Priboj Vranjski 17511',
        'Pričević 14251',
        'Pridvorice 11420',
        'Prigrevica 25263',
        'Prijepolje 31300',
        'Prijevor 32205',       
        'Prilički Kiseljak 32252',
        'Prilike 32252',
        'Prilužje 38213',             
        'Prislonica 32212',
        'Priština 38101',
        'Privina Glava 22257',
        'Prizren 38400',
        'Prnjavor (Mačvan.) 15306',
        'Progar 11280',       
        'Progorelica 36201',
        'Prokuplje 18400',
        'Prolom 18433',             
        'Provo 15215',
        'Pružatovac 11413',
        'Prva Kutina 18205',
        'Pudarci 11430',
        'Puhovo 32240',
        'Pukovac 18255',       
        'Putinci 22404',
        'Rabrovac 11412',
        'Rabrovo 12254',             
        'Rača 18440',
        'Rača Kragujevačka 34210',
        'Radalj 15321',
        'Radaljevo 32252',
        'Radenković 22206',
        'Radičević 21225',       
        'Radinac 11311',
        'Radljevo 14211',
        'Radojevo 23221',             
        'Radovnica 17526',
        'Radujevac 19334',
        'Rađevo Selo 14000',
        'Rajac 19314',             
        'Rajčinoviće 36308',
        'Rajkovac 11400',
        'Rajković 14202',
        'Rajno Polje 16201',
        'Rakinac 11327',
        'Rakitovo 35000',       
        'Rakoš 38336',
        'Rakovac 17520',
        'Rakovac 21299',             
        'Ralja 11233',
        'Ranilović 34302',
        'Ranilug 38267',  
        'Ranovac 12304',             
        'Rasna 31210',
        'Rastina 25283',
        'Rašanac 12315',
        'Raševica 35206',
        'Raška 36350',
        'Rataje 37236',       
        'Ratare 35256',
        'Ratari 11411',
        'Ratari 11509',             
        'Ratina 36212',
        'Ratkovo 25253',
        'Ravna Dubrava 18246',  
        'Ravna Reka 35235',             
        'Ravni 31206',
        'Ravni Topolovac 23212',
        'Ravno Selo 21471',
        'Ravnje 22205',
        'Razbojna 37223',
        'Razgojna 16252',       
        'Ražana 31265',
        'Ražanj 37215',
        'Rečane 38411',             
        'Rekovac 35260',
        'Reljan 17556',
        'Resavica 35237',  
        'Resnik 18230',             
        'Resnik 34225',
        'Rgotina 19214',
        'Ribare 35220',
        'Ribare 37205',
        'Ribari 15310',
        'Ribarići 36309',       
        'Ribarska Banja 37205',
        'Ribnica 36103',
        'Riđica 25280',             
        'Ripanj 11232',
        'Ristovac 17521',
        'Ritiševo 26331',  
        'Ritopek 11307',             
        'Roćevac 35211',
        'Roćevići 36205',
        'Rogača	11453',
        'Rogačica 31255',
        'Roge 31237',
        'Rogljevo 19318',       
        'Rogovo 38434',
        'Rožanstvo 31208',
        'Rudna Glava 19257',             
        'Rudnica 36353',
        'Rudnik 32313',
        'Rudno 36222',  
        'Rudovci 11566',             
        'Ruđinci 36210',
        'Ruma 22400',
        'Rumenka 21201',
        'Ruplje 16223',
        'Ruski Krstur 25233',
        'Rusko Selo 23314',       
        'Rušanj 11194',
        'Rutevac 18224',
        'Rvati 11500',             
        'Rznić 38328',
        'Sajan 23324',
        'Sakule 26206',  
        'Salakovac 12311',             
        'Salaš 19224',
        'Salaš Noćajski 22204',
        'Samaila 36202',
        'Samoš 26350',
        'Sanad 23331',
        'Saraorci 11315',       
        'Sastav Reka 16213',
        'Sastavci 31335',
        'Savinac 19377',             
        'Savino Selo 21467',
        'Seča Reka 31262',
        'Sečanj 23240',
        'Sedlare 35211',
        'Sedlari 14000',             
        'Sefkerin 26203',
        'Selenča 21425',
        'Seleuš 26351', 
        'Selevac 11407',
        'Selište 37245',             
        'Senta 24400',
        'Senje 35233',
        'Senjski Rudnik 35234', 
        'Seone 11300',
        'Sevojno 31205',             
        'Sibač 22440',
        'Sibnica 11454',
        'Sićevo 18311',  
        'Sijarinska Banja 16246',
        'Sikirica 35256',             
        'Sikole 19225',
        'Silbaš 21433',
        'Simićevo 12373',
        'Siokovac 35203',
        'Sip 19326',             
        'Sipić 34213',
        'Sirakovo 12221',
        'Sirča 36208',
        'Sirig 21214',
        'Sirogojno 31207',             
        'Sivac 25223',
        'Sjenica 36310',
        'Skela 11509', 
        'Skivjane 38325',
        'Skobalj 11322',             
        'Skorenovac 26228',
        'Skorica 37213',
        'Skupljen 15225', 
        'Slanci 11215',
        'Slankamen.Vinogradi 22318',             
        'Slatina 19221',
        'Slatina 19324',
        'Slatina 32224',  
        'Slavkovica 14245',
        'Slivovo 38259',             
        'Slovac 14223',
        'Smederevo 11300',
        'Smederevska Palanka 11420', 
        'Smilovci 18323',
        'Smoljinac 12312',             
        'Sočanica 38217',
        'Sokobanja 18230',
        'Sombor 25000',
        'Sombor 25101',
        'Sonta 25264',             
        'Sopoćani 36308',
        'Sopot 11450',
        'Sot 22243', 
        'Srbica 38338',
        'Srbobran 21480',             
        'Srednjevo 12253',
        'Sredska 38406',
        'Sremčica 11253', 
        'Sremska Kamenica 21208',
        'Sremska Mitrovica 22000',             
        'Sremska Rača 22247',
        'Sremski Karlovci 21205',
        'Sremski Mihaljevci 22413',  
        'Srpska Crnja 23220',
        'Srpski Babuš 38235',             
        'Srpski Itebej 23233',
        'Srpski Krstur 23334',
        'Srpski Miletić 25244', 
        'Stajićevo 23204',
        'Stalać 37212',             
        'Stanišić 25284',
        'Stanjevo 37234',
        'Stapar 25240',
        'Stara Moravica 24340',
        'Stara Pazova 22300',             
        'Starčevo 26232',
        'Stari Banovci 22305',
        'Stari Lec 26371', 
        'Stari Slankamen 22329',
        'Stari Trstenik 37242',             
        'Stari Žednik 24224',
        'Staro Selo 11324',
        'Stave 14255', 
        'Stejanovci 22405',
        'Stenjevac 35215',             
        'Stepanovićevo 21212',
        'Stepojevac 11564',
        'Stojnik 34307',  
        'Stopanja 37242',
        'Stragari 34323',             
        'Straža 15307',
        'Straža 26345',
        'Strelac 18332', 
        'Strezovce 38262',
        'Striža 35250',             
        'Strižilo 35269',
        'Strojkovce 16203',
        'Stubica 35254',
        'Stubline 11507',
        'Studenica 36343',             
        'Stupčevići 31236',
        'Subotica 24000',
        'Subotica (kod Svilajnca) 35209', 
        'Subotinac 18227',
        'Subotište 22414',             
        'Sukovo 18322',
        'Sumrakovac 19376',
        'Supska 35228', 
        'Surčin 11271',
        'Surduk 22307',             
        'Surdulica 17530',
        'Susek 21313',
        'Sutjeska 23244',  
        'Suva Reka 38410',
        'Suvi Do 12322',             
        'Sveti Ilija 17508',
        'Svetozar Miletić 25211',
        'Svilajnac 35210', 
        'Svileuva 15221',
        'Svilojevo 25265',             
        'Svođe 16212',
        'Svojnovo 35259',
        'Svrljig 18360',
        'Šabac 15000',
        'Šajkaš 21244',             
        'Šanac 37252',
        'Šapine 12312',
        'Šarbanovac 18235', 
        'Šarbanovac 19373',
        'Šašinci 22425',             
        'Šepšin 11433',
        'Šetonje 12309',
        'Šid 22240', 
        'Šilopaj 32311',
        'Šimanovci 22310',             
        'Šljivovac 34219',
        'Šljivovica 31244',
        'Šljivovo 37239',  
        'Štavalj 36311',
        'Štimlje 38412',             
        'Štitar 15354',
        'Štitare 36314',
        'Štrpce 8236', 
        'Štubik 19303',
        'Štulac 36210',             
        'Šume 32250',
        'Šupljak 24418',
        'Šurjan 23254',
        'Tabanovac 12307',
        'Tabanović 15211',             
        'Takovo 32304',
        'Taraš 23209',
        'Tavnik 36204', 
        'Tečić 35260',
        'Tekeriš 15234',             
        'Tekija 19325',
        'Tekija 35250',
        'Telečka 25222', 
        'Temerin 21235',
        'Temska 18355',             
        'Tešica 18212',
        'Titel 21240',
        'Toba 23222',  
        'Tomaševac 23262',
        'Topola 34310',             
        'Topolovnik 12226',
        'Toponica 18244',
        'Toponica 34243',
        'Torda 23214',             
        'Tornjoš 24352',
        'Totovo Selo 24427',
        'Tovariševo 21424',
        'Trbušac 15213',             
        'Trbušani 32205',
        'Trešnjevac 24426',
        'Trešnjevica 35248',
        'Trgovište 17525',             
        'Trlić 14210',
        'Trnava 32221',
        'Trnava  35000',
        'Trnavci 37235',             
        'Trnjane 19306',
        'Troponje 35211',
        'Trstenica 11500',
        'Trstenik 37240',             
        'Tršić 15303',
        'Trupale 18211',
        'Tubravić 14206',
        'Tulare 16247',             
        'Turekovac 16231',
        'Turija 12257',
        'Turija 21215',
        'Tutin 36320',             
        'Ub 14210',
        'Ugao 36313',
        'Ugljarevo 37240',
        'Ugrinovci 11277',             
        'Ugrinovci 32314',
        'Uljma 26330',
        'Umčari 11430',
        'Umka 11260',             
        'Uroševac 38230',
        'Urovica 19305',
        'Usije 12222', 
        'Ušće 36342',             
        'Utrine 24437',
        'Uzdin 26216',
        'Uzovnica 15319',
        'Užice 31000',             
        'Užice 31102',
        'Vajska 21426',
        'Valjevo 14000',
        'Varda 31263',             
        'Varna 15232',
        'Varvarin 37260',
        'Vasilj 19367',
        'Vašica 22241',             
        'Vatin 26337',
        'Velereč 32300',
        'Velesnica 19328',
        'Velika Drenova 37245',             
        'Velika Grabovica 16221',
        'Velika Greda 26366',
        'Velika Hoča 38429',
        'Velika Ivanča 11414',             
        'Velika Krsna 11408',
        'Velika Kruša 38433',
        'Velika Lomnica 37209',
        'Velika Moštanica 11262',             
        'Velika Plana 11320',
        'Velika Plana 18403',
        'Velika Reka 15322',
        'Velika Vrbica 19320',             
        'Velika Vrbnica 37233',
        'Veliki Borak 11462',
        'Veliki Crljeni 11563',
        'Veliki Gaj	26365',             
        'Veliki Izvor 19206',
        'Veliki Popovac 12315',
        'Veliki Popović 35223',
        'Veliki Radinci 22211',             
        'Veliki Šiljegovac 37204',
        'Veliki Trnovac 17528',
        'Veliko Bonjince 18215',
        'Veliko Golovode 37207',             
        'Veliko Gradište 12220',
        'Veliko Laole 12306',
        'Veliko Orašje 11323',
        'Veliko Polje 11500',             
        'Veliko Selo 11060',
        'Veliko Selo 12314',
        'Veliko Selo 18307',
        'Veliko Središte 26334',             
        'Venčane 34306',
        'Veternik 21203',
        'Viča 32233',
        'Vilovo 21246',             
        'Vina 19368',
        'Vinarce 16000',
        'Vinča 11307',
        'Vionica 32254',             
        'Virine 35230',
        'Visibaba 31210',
        'Visočka Ržana 18306',
        'Višnjevac 24222',             
        'Višnjićevo 22246',
        'Vitanovac 36206',
        'Vitina 38257',
        'Vitkovac 36207',             
        'Vitkovo 37230',
        'Vitojevci 22431',
        'Vitomirica 38331',
        'Vitoševac 37213',             
        'Vladičin Han 17510',
        'Vladimirci 15225',
        'Vladimirovac 26315',
        'Vlajkovac 26332',             
        'Vlase 17507',
        'Vlasina Okruglica 17532',
        'Vlasina Rid 17533',
        'Vlasina Stojkovićeva 17534',             
        'Vlasotince 16210',
        'Vlaška 11406',
        'Vlaški Do 12371',
        'Vodanj 11328',             
        'Voganj 22429',
        'Vojka 22313',
        'Vojska 35208',
        'Vojvoda Stepa 23219',             
        'Voluja 12256',
        'Vračev Gaj 26348',
        'Vraćevšnica 32315',
        'Vragočanica 14255',
        'Vrane 31230',
        'Vranić 11427',
        'Vranovo 11329',             
        'Vranje 17000',
        'Vranjska Banja 17542',
        'Vratarnica 19344',
        'Vražogrnac 19312',
        'Vrba	36214',
        'Vrbas 21460',
        'Vrbica 23329',             
        'Vrčin 11224',
        'Vrdnik 22408',
        'Vreoci 11560',
        'Vrhpolje 15324',
        'Vrmdža 18236',
        'Vrnjačka Banja 36210',
        'Vrnjci 36210',             
        'Vršac 26300',
        'Vrtište 18202',
        'Vučak 11300',
        'Vučitrn 38214',
        'Vučje 16203',
        'Vučkovica 34240',
        'Vukovac 12318',             
        'Zablaće 32223',
        'Zabojnica 34244',
        'Zabrđe 12300',
        'Zabrežje 11505',
        'Zagajica 26344',
        'Zajača 15315',
        'Zaječar 19000',             
        'Zaklopača 11306',
        'Zaovine 31251',
        'Zasavica 22201',
        'Zavlaka 15312',
        'Zdravinje 37203',
        'Zjum 38432',
        'Zlatari 37228',             
        'Zlatibor 31315',
        'Zloćudovo 16000',
        'Zlodol 31253',
        'Zlot 19215',
        'Zmajevo 21213',
        'Zminjak 15352',
        'Zrenjanin 23000',
        'Zrze 38435',
        'Zubin Potok 38228',
        'Zuce 11225',
        'Zvečan 38227',
        'Zvečka 11500',
        'Zvezda 15215',
        'Zvezdan 19227',
        'Zvonce 18333',
        'Žabalj 21230',
        'Žabari 12374',
        'Žagubica 12320',
        'Žaočani 32224',
        'Žarkovac 22400',
        'Ždeglovo 16230',
        'Žiča 36221',
        'Žirovnica 34229',
        'Žitište 23210',
        'Žitkovac 18210',
        'Žitni Potok 18407',
        'Žitorađa 18412',
        'Žuč 18438',
        'Žučkovac 18230',
      ],
      nameRules: [
        v => !!v || 'Unesite ime Vašeg servisa.',
      ],
      phoneRules: [
        v => !!v || 'Unesite ime Vaš broj telefona.',
      ],
      pibRules: [
        v => !!v || 'Unesite Vaš PIB.',
      ],
      ownerRules: [
        v => !!v || 'Unesite ime i prezime vlasnika servisa.',
      ],
      adressRules: [
        v => !!v || 'Unesite naziv ulice servisa.',
      ],
      numRules: [
        v => !!v || 'Unesite broj ulice servisa.',
      ],
      cityRules: [
        v => !!v || 'Mesto u kom se nalazi servis.',
      ],
      profile: {
      name: null,
      // phone: null,
      pib: null,
      owner: null,
      adress: null,
      num: null,
      city: null
      },

    }),

    firestore() {
      const user = fb.auth().currentUser
      return {
        profile: db.collection('accounts').doc(user.uid)
      }
    },
    mounted:function(){
        this.method1() //method1 will execute at pageload
    },
    methods: {

        updateProfile() {  
          firebase.auth().onAuthStateChanged(function(user) {
              if (user) {
              db.collection("accounts").doc(user.uid)
                console.log("user ID: ",user.uid)
              .catch(function(error) {
                console.log("Got an error: ",error);
                });
              } else {
                // No user is signed in.
              }
            })
          this.$firestore.profile.set(this.profile)
          this.$router.push('/dobavljaci')
      },
        method1:function(){

            const user = fb.auth().currentUser
            var docRef = db.collection("accounts").doc(user.uid);

            docRef.get().then(function(doc) {
                if (doc.exists && doc.data().name) {
                    // this.$router.push('/')
                    window.location = 'https://club.bilsteingroup.com/bodovi'
                    window.location.href == 'https://club.bilsteingroup.com/bodovi'
                    
                } else {
                  console.log("Form must be valid");
                }
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });

        },
        
    },
  }
</script>

<style>
.vti-wrap input{
  min-height: 56px;
  width: 100%;
}
.plr-none{
    padding:0 10px!important;
}
</style>

    